import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'

class ShopTapBoxV2 extends Component {
  render() {
    const tap = this.props.tap
    const shopId = this.props.shopId
    const service = $('.shopSelectText').attr('data-service')

    let classNmae = "tap5 commonBtn notLine"

    if(Number(service) === 6) {
      classNmae = "tap5 commonBtn notLine hide"
    } else {
      classNmae = "tap5 commonBtn notLine"
    }

    $(`.${ tap }`).addClass('active')

    return (
      <div className='shopTapBox'>
        <button className='tap1 commonBtn notLine'><Link to={`/v2/shopInfo1?shopSelect=${ shopId }`}>기본정보</Link></button>
        <button className='tap2 commonBtn notLine'><Link to={`/v2/shopInfo2?shopSelect=${ shopId }`}>대표 이미지</Link></button>
        <button className='tap3 commonBtn notLine'><Link to={`/v2/shopInfo3?shopSelect=${ shopId }`}>운영 정보</Link></button>
        <button className='tap4 commonBtn notLine'><Link to={`/v2/shopInfo4?shopSelect=${ shopId }`}>주문 정보</Link></button>
        <button className={ classNmae }><Link to="" onClick={() => window.location.href = `/v2/shopInfo5?shopSelect=${ shopId }`}>배달권역</Link></button>
      </div>
    )
  }
}

export { ShopTapBoxV2 }